import { getToken } from "../../common/environment_config.es6";
import { apiGet } from "../../common/http_service";

export class SceneAudioService {
  static async getSceneAudios(params = {}) {
    let { trainingId } = params;

    // trainingId: explicit param > global idealStudioTrainingId
    if (!trainingId) {
      trainingId = window.idealStudioTrainingId || "";
    }

    if (!trainingId) {
      throw new Error("trainingId is missing for getSceneAudios");
    }

    // Base URL: same pattern as fetchIdealStudioFiles (ideaLibraryRootUrl + origin)
    if (!window.ideaLibraryRootUrl) {
      throw new Error("ideaLibraryRootUrl not configured for scene audios");
    }

    let baseUrl = window.ideaLibraryRootUrl;
    if (!baseUrl.toLowerCase().startsWith("http")) {
      baseUrl = window.location.origin + baseUrl;
    }

    if (!baseUrl.endsWith("/")) {
      baseUrl += "/";
    }

    // Final endpoint: {{baseUrl}}/api/ideal-studio/studio/trainings/{{trainingId}}/scene-audios
    const url = `${baseUrl}api/studio/trainings/${trainingId}/scene-audios`;

    const headers = {};

    const token = getToken && getToken();
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const tenantId = window.tenantId;
    if (tenantId) {
      headers["Abp.TenantId"] = tenantId;
    }

    const response = await apiGet(url, { headers });
    if (!response.ok) {
      throw new Error(`Scene audios request failed with status ${response.status}`);
    }

    return response.json();
  }
}

export default SceneAudioService;
